import {
  defaultEditableFields,
  useFindingEditStore,
} from '../store/findingEditStore';

export function formatFindingLinkedObjectRawText({
  findingId,
  label,
  title,
  untrustedDataNotice,
}: {
  findingId: string;
  label?: string;
  title: string;
  untrustedDataNotice: string;
}): string {
  const editState = useFindingEditStore
    .getState()
    .getFindingEditState(findingId);
  const draft = editState?.editableFields ?? defaultEditableFields;

  return [
    title,
    untrustedDataNotice,
    '',
    JSON.stringify(
      {
        objectKind: 'Finding',
        findingId,
        label: label ?? null,
        mode: editState?.mode ?? 'view',
        draft,
      },
      null,
      2,
    ),
  ].join('\n');
}
